import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  LinearProgress,
  CircularProgress
} from '@mui/material';
import { IoMdAdd } from "react-icons/io";
import AddXmlDialog from './AddXmlDialog';
import xmlDealerService from '../../../../services/xmlDealerService';
import { useSelector } from 'react-redux';
import DeleteIcon from '@mui/icons-material/Delete';
import useAlert from '../../../../hooks/useAlert';
import PersonIcon from '@mui/icons-material/Person';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const getXmlLoadStateText = (state) => {
  switch (state) {
    case 1: return 'Bekliyor';
    case 2: return 'Devam Ediyor';
    case 3: return 'Tamamlandı';
    case 9: return 'Hata';
    default: return '-';
  }
};

export const XmlDealer = () => {
  const [xml, setXml] = useState([]);
  const [xmlDetail, setXmlDetail] = useState([]);
  const [xmlDealerShipId, setXmlDealerShipId] = useState(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const authUserId = useSelector(state => state?.auth?.user?.id);
  const { showErrorAlertAll, showSuccessAlertAll } = useAlert();

  const deleteXml = async (id) => {
    try {
      await xmlDealerService.deleteXml(id);
      showSuccessAlertAll();
    } catch {
      showErrorAlertAll();
    }
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const getXml = async () => {
    var response = await xmlDealerService.fetchXmls(xmlDealerShipId);
    setXmlDetail(response?.data);
  }

  useEffect(() => {
    const getShip = async () => {
      try {
        setLoading(true);
        var response = await xmlDealerService.fetchDealerShip(authUserId);
        setXmlDealerShipId(response?.data[0]?.id);
        setXml(response?.data);
        setLoading(false);
      } catch {
        setLoading(false);
      }

    }
    getShip();
  }, []);

  const flattenedData = xml[0]?.userDealerShips.map(dealer => ({
    ...dealer.xmlDealerUser,
    name: dealer.name,
    surName: dealer.surName,
    userName: dealer.userName,
    phone: dealer.phone,
    userId: dealer.id,
  })) || [];

  return (
    <>
      {

        <Box sx={{ width: '100%', padding: 4, backgroundColor: '#f5f5f5' }}>

          <Box sx={{
            padding: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 3,
            backgroundColor: '#fff',
            borderRadius: 2,
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ width: 4, height: 24, backgroundColor: '#b71c1c', mr: 1 }} />
              <Typography variant="h6" color="black" sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                XML
              </Typography>
            </Box>
            <Button
              variant="contained"
              onClick={handleOpen}
              sx={{
                borderRadius: 2,
                backgroundColor: '#1F1B45',
                color: '#FFFFFF',
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '0.875rem',
                padding: '10px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                height: '40px',
                boxShadow: '0 4px 8px rgba(31, 27, 69, 0.3)',
                '&:hover': {
                  backgroundColor: '#2C285A',
                  boxShadow: '0 6px 12px rgba(31, 27, 69, 0.4)',
                },
              }}
            >
              <IoMdAdd />
              Oluştur
            </Button>
          </Box>

          {loading ? <CircularProgress sx={{ mt: 5 }} /> :
            <>
              <Box sx={{ p: 2, mb: 2, backgroundColor: "white", borderRadius: 1 }}>
                <Typography variant="h6" sx={{ mb: 2 }}>XML Durumu</Typography>
                <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Tedarikçi</TableCell>
                        <TableCell>Durum</TableCell>
                        <TableCell>İlerleme</TableCell>
                        <TableCell>Sonraki Çalışma Tarihi</TableCell>
                        <TableCell>Oluşturma Tarihi</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {xml.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{item.providerName}</TableCell>
                          <TableCell>
                            <Box sx={{
                              backgroundColor: item.xmlLoadState === 3 ? '#e8f5e9' :
                                item.xmlLoadState === 2 ? '#fff3e0' :
                                  item.xmlLoadState === 9 ? '#ffebee' : '#f5f5f5',
                              padding: '4px 8px',
                              borderRadius: '4px',
                              display: 'inline-block'
                            }}>
                              {getXmlLoadStateText(item.xmlLoadState)}
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <LinearProgress
                                variant="determinate"
                                value={item.xmlLoadPercent}
                                sx={{ width: '100px' }}
                              />
                              <Typography variant="body2">
                                {item.xmlLoadPercent}%
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            {new Date(item.nextRun).toLocaleString('tr-TR', {
                              dateStyle: 'short',
                              timeStyle: 'short',
                            })}
                          </TableCell>
                          <TableCell>
                            {new Date(item.createDate).toLocaleDateString('tr-TR')}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>


              <Box sx={{ p: 2, backgroundColor: "white", borderRadius: 1 }}>
                {xml.length === 0 ? (
                  <Typography align="center" sx={{ mt: 2 }}>
                    Henüz kayıtlı XML yok.
                  </Typography>
                ) : (
                  <div className="w-full p-4">
                    <TableContainer component={Paper} className="max-h-[70vh] shadow-md rounded-lg">
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow className="bg-gray-50">
                            <TableCell className="font-bold text-gray-700">Kullanıcı Bilgileri</TableCell>
                            <TableCell className="font-bold text-gray-700">Link</TableCell>
                            <TableCell className="font-bold text-gray-700">Geçerlilik Tarihi</TableCell>
                            <TableCell className="font-bold text-gray-700">İşlemler</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {flattenedData?.map((item, index) => (
                            item.accessLink != null ?
                              <TableRow key={index} className="hover:bg-gray-50 transition-colors">
                                <TableCell>
                                  <div className="flex items-center gap-2">
                                    <PersonIcon className="text-gray-600" />
                                    <div>
                                      <div className="font-medium">{item.name} {item.surName}</div>
                                      <div className="text-sm text-gray-500">{item.userName}</div>
                                      <div className="text-sm text-gray-500">{item.phone}</div>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell>{item.accessLink}</TableCell>
                                <TableCell>
                                  {item.validityDate
                                    ? new Date(item.validityDate).toLocaleDateString('tr-TR')
                                    : '-'
                                  }
                                </TableCell>
                                <TableCell>
                                  <Button
                                    onClick={() => deleteXml(item.userId)}
                                    variant="outlined"
                                    className="rounded-lg border border-indigo-900 text-indigo-900 normal-case 
                               hover:bg-gray-100 hover:border-indigo-800 hover:text-indigo-800
                               flex items-center gap-2 px-3 py-1.5"
                                    size="small"
                                  >
                                    <DeleteIcon className="w-4 h-4" />
                                    Sil
                                  </Button>
                                </TableCell>
                              </TableRow> : null
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                )}
              </Box></>

          }

          <AddXmlDialog open={open} onClose={handleClose} />
        </Box>
      }

    </>

  );
};

export default XmlDealer;